var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('BaseCard',{attrs:{"heading":"INICIO"}},[_c('div',[_c('v-card-text',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12"}})],1)],1)],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }